import { SYS3060_R01Dto } from "src/containers/mes/SYS/SYS3060_R01/Dto_SYS3060_R01";
import { ResponseDto } from "src/dtos/common/responseDto";
import config from "src/config";
import { getData, postData, putData, patchData, deleteData } from "src/utils/axios/serverHelper";
import { SYS3060_R01Filter } from "./Store_SYS3060_R01";

const baseUrl = `${config.apiUrl}/SYS3060_R01`;

/**
 * 메뉴 권한 목록 조회 (GET)
 * Menu 테이블과 AutGroup 테이블을 LEFT JOIN하여 모든 메뉴 + 해당 권한그룹의 권한 정보를 반환
 */
export const getMenuAuthorityList = async (option: string, params: Partial<SYS3060_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${option}`;
  return await getData<ResponseDto<SYS3060_R01Dto[]>>(url, {
    params: {
      	...params,
			listLength
		}
	});
};

export const getMenuAuthorityAllCount = async (params: Partial<SYS3060_R01Filter>) => {
	const url = `${baseUrl}/allCount`;

	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
}

/**
 * 메뉴 권한 등록 (POST)
 */
export const createMenuAuthority = async (data: SYS3060_R01Dto) => {
//   console.log('메뉴 권한 등록 API 호출 URL:', baseUrl);
//   console.log('등록 데이터:', data);
  return await postData<SYS3060_R01Dto, ResponseDto<void>>(baseUrl, data);
};

/**
 * 메뉴 권한 수정 (PATCH)
 */
export const updateMenuAuthority = async (data: SYS3060_R01Dto) => {
//   console.log('메뉴 권한 수정 API 호출 URL:', baseUrl);
//   console.log('수정 데이터:', data);
  return await patchData<SYS3060_R01Dto, ResponseDto<void>>(baseUrl, data);
};

/**
 * 메뉴 권한 upsert (PUT)
 * 존재하면 수정, 없으면 생성
 */
export const upsertMenuAuthority = async (data: SYS3060_R01Dto) => {
//   console.log('메뉴 권한 upsert API 호출 URL:', baseUrl);
//   console.log('upsert 데이터:', data);
  return await putData<SYS3060_R01Dto, ResponseDto<void>>(baseUrl, data);
};

/**
 * 메뉴 권한 삭제 (DELETE)
 */
export const deleteMenuAuthority = async (autGroupCd: string, menuCd: string) => {
//   console.log('메뉴 권한 삭제 API 호출 URL:', baseUrl);
//   console.log('삭제 파라미터:', { autGroupCd, menuCd });
  return await deleteData<ResponseDto<void>>(baseUrl, { 
    params: { autGroupCd, menuCd } 
  });
};

/**
 * 엑셀 다운로드 (GET)
 */
export const downloadExcel_SYS3060_R01 = async (option: string, params: Partial<SYS3060_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`;
	// console.log('엑셀 다운로드 API 호출 URL:', url);
	return await getData<ResponseDto<string>>(url, {
		params: {
			...params,
			listLength
		}
	});
};
